import { z } from "zod";

import { HydraEnum } from "@/TS/Enums/global_enums";
import { CustomError } from "@/utils/init-globals";

import { internalRoutes } from "../internal-routes";

import { ContactTopicResponseSchema } from "./helpdesk-schema";

export const helpdeskApi = {
  getPublicContactTopics: async () => {
    try {
      const response = await fetch(internalRoutes.helpdesk);

      if (!response.ok) {
        throw new CustomError(
          "Une erreur est survenue, impossible de récupérer les sujets de contact",
        );
      }

      const rawData = await response.json();

      const validatedData = ContactTopicResponseSchema.parse(rawData);
      return validatedData[HydraEnum.LIST];
    } catch (error) {
      if (error instanceof z.ZodError) {
        const firstError = error.issues[0];
        const path = firstError.path.join(".");
        const value =
          "received" in firstError
            ? JSON.stringify(firstError.received)
            : "unknown";

        console.error(`Erreur de validation Zod:
          - Champ: ${path}
          - Problème: ${firstError.message}
          - Valeur reçue: ${value}
          (${error.issues.length - 1} autres erreurs similaires)`);

        throw new CustomError(
          `Erreur de format: ${path} invalide (${firstError.message})`,
        );
      }
      throw error;
    }
  },
};
